export default __webpack_public_path__ + "media/zurb/img/events/wired/family-giving/fg-4-503874b7264587e835eeee2bc0fb806c.jpg";